__turbopack_context__.v({
  "businessInfo": "_wGSFG_businessInfo",
  "restaurantContainer": "_wGSFG_restaurantContainer",
  "restaurantHeader": "_wGSFG_restaurantHeader",
});
